module.exports = __webpack_public_path__ + "img/move-to.3bb1a9b9.webp";